<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>调剂</el-breadcrumb-item>
        <el-breadcrumb-item>补充调剂信息审核</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">员工调剂信息</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="SupplementCreateVisible=!SupplementCreateVisible"
          >新建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="年份"
          prop="name"
        >
          <el-select
            v-model="query.year"
            placeholder="请选择"
            @change="fetchAdjustAddlist(true)"
            clearable
            @clear="delete_value('year')"
          >
            <el-option label="2027" value="2027"></el-option>
            <el-option label="2026" value="2026"></el-option>
            <el-option label="2025" value="2025"></el-option>
            <el-option label="2024" value="2024"></el-option>
            <el-option label="2023" value="2023"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校标签">
          <el-select
            v-model="query.college_categorys"
            filterable
            collapse-tags
            placeholder="请选择"
            clearable
            @change="fetchAdjustAddlist(true)"
            @clear="delete_value('college_categorys')"
          >
            <el-option
              v-for="(item, index) in categorys"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="院校名称"
          prop="college_name"
        >
          <el-select
            v-model="query.college_keyword"
            filterable
            collapse-tags
            placeholder="请选择"
            clearable
            @change="fetchAdjustAddlist(true)"
            @clear="delete_value('college_keyword')"
          >
            <el-option
              v-for="(item, index) in $store.state.collegeList"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="专业类型"
          prop="name"
        >
          <el-select
            v-model="query.major_type"
            placeholder="请选择"
            @change="fetchAdjustAddlist(true)"
            clearable
            @clear="delete_value('major_type')"
          >
            <el-option
              label="学术型"
              :value="1"
            ></el-option>
            <el-option
              label="专业型"
              :value="2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="招生类型"
          prop="name"
        >
          <el-select
            v-model="query.enrol_type"
            placeholder="请选择"
            @change="fetchAdjustAddlist(true)"
            clearable
            @clear="delete_value('enrol_type')"
          >
            <el-option
              label="全日制"
              :value="1"
            ></el-option>
            <el-option
              label="非全日制"
              :value="2"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">调剂列表</h3>
        <el-form
          label-width="70px"
          size="small"
        >
        </el-form>
      </div>
      <div class="values">
        <el-table
          :data="tableData"
          border
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
            width="70"
            fixed="left"
          >
          </el-table-column>
          <el-table-column
            prop="year"
            label="年份"
            align="center"
            width="70"
          >
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="院校名称"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="专业名称"
            align="center"
            width="210"
          >
            <template slot-scope="scope">
              <span>{{`(${scope.row.major_code})${scope.row.major_name}`}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="academy_name"
            label="学院名称"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="拟招生调剂人数"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{scope.row.user_count}}人</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="contact_name"
            label="联系老师"
            align="center"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="contact_mobile"
            label="联系方式"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="other_remark"
            label="备注"
            align="center"
            width="300"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="source_website"
            label="原文地址"
            align="center"
            width="190"
          >
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="提交人"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="操作"
            align="center"
            width="120"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openSupplementEditVisible(scope.row)"
              >编辑</el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="danger"
                :underline="false"
                @click="deleteItem(scope.row)"
              >删除</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                  ><span
                      @click="openSupplementEditVisible(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="deleteItem(scope.row)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <SupplementEdit
      :visible="SupplementEditVisible"
      @close="closeSupplementEditVisible"
      :content="SupplementEditContent"
      :userType="2"
    />
    <SupplementCreate
      :visible="SupplementCreateVisible"
      @close="closeSupplementCreateVisible"
    />
  </div>
</template>

<script>
import { adjustAddlist, deleteAdjustAdd } from "@/api/adjust";
import SupplementEdit from "@/components/dialog/supplement/SupplementEdit.vue";
import SupplementCreate from "@/components/dialog/supplement/SupplementCreate.vue";
import { collegeCategoryList } from '@/api/common'
export default {
  components: {
    SupplementEdit,
    SupplementCreate
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        user_type: 2,
      },
      pageTotal: 0,
      createDatetime: "",
      tableData: [],
      SupplementEditVisible: false,//编辑弹窗
      SupplementCreateVisible: false,//创建弹窗
      SupplementEditContent: {},
      userType: 2,
      categorys: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.fetchAdjustAddlist()
    this.fetchCategoryList()
    this.$store.dispatch("getAllColleges");
  },
  methods: {
    // 分类列表请求
    fetchCategoryList() {
      collegeCategoryList({ isPaging: 0 }).then(res => {
        this.categorys = res.list
      })
    },
    fetchAdjustAddlist(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      adjustAddlist(this.query).then(res => {
        this.tableData = res.list || []
        this.pageTotal = res.count
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.fetchAdjustAddlist();
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.fetchAdjustAddlist();
    },
    openSupplementEditVisible(item) {
      this.userType = 2
      this.SupplementEditContent = JSON.parse(JSON.stringify(item))
      this.SupplementEditVisible = !this.SupplementEditVisible
    },
    closeSupplementEditVisible() {
      this.SupplementEditVisible = false
      this.fetchAdjustAddlist()
    },
    closeSupplementCreateVisible() {
      this.SupplementCreateVisible = false
      this.fetchAdjustAddlist()
    },
    // 接口筛选后端不能接收空值，所以在清除的时候去删掉这个属性
    delete_value(value) {
      this.$delete(this.query, value)
      this.fetchAdjustAddlist()
    },
    deleteItem(item) {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAdjustAdd({ id: item.id }).then((res) => {
            this.$nextTick(() => {
              this.fetchAdjustAddlist();
            });
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "提示",
            message: "已取消删除",
          });
        });
    },
  }
};
</script>

<style lang="less" scoped>
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
}
</style>